module.exports = __webpack_public_path__ + "img/question-icon.5ce2ba88.svg";